import React, { useEffect, useState } from "react";
import { Box, Collapse, Link } from "@mui/material";
import LocalOfferOutlined from "@mui/icons-material/LocalOfferOutlined";
import { api } from "../../services/api";
import { Campo, PRIMARIO } from "../ui/Formulario";

// Sólo aparece si el evento tiene canales activos.
const CampoCodigoCanal = ({ eventoId, value, onChange }) => {
  const [usaCodigos, setUsaCodigos] = useState(false);
  const [abierto, setAbierto] = useState(Boolean(value));

  useEffect(() => {
    let vigente = true;
    api.canales
      .usaCodigos(eventoId)
      .then((r) => vigente && setUsaCodigos(Boolean(r?.data?.usa_codigos)))
      .catch(() => {});
    return () => {
      vigente = false;
    };
  }, [eventoId]);

  if (!usaCodigos) return null;

  return (
    <Box sx={{ my: 1.5 }}>
      {!abierto && (
        <Link
          component="button"
          type="button"
          underline="hover"
          onClick={() => setAbierto(true)}
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.75, fontSize: 13, color: PRIMARIO }}
        >
          <LocalOfferOutlined sx={{ fontSize: 16 }} />
          ¿Tenés un código de quien te recomendó?
        </Link>
      )}
      <Collapse in={abierto}>
        <Campo
          etiqueta="Código de quien te recomendó (opcional)"
          placeholder="Ej.: ACADEMIASOL"
          value={value}
          onChange={(e) => onChange(e.target.value.toUpperCase().replace(/\s/g, "").slice(0, 40))}
          ayuda="No cambia el precio."
          inputProps={{ autoCapitalize: "characters" }}
        />
      </Collapse>
    </Box>
  );
};

export default CampoCodigoCanal;
